import { z } from 'zod'
import { TelegramConnectionStatus } from '../../enums'

export const telegramStatusResponseSchema = z.object({
  connected: z.boolean(),
  status: z.nativeEnum(TelegramConnectionStatus).nullable(),
  username: z.string().nullable(),
  linkedAt: z.string().nullable(),
  lastFailedAt: z.string().nullable(),
  failureReason: z.string().nullable(),
})

export type TelegramStatusResponseDto = z.infer<typeof telegramStatusResponseSchema>
